import { z } from "zod";

const colorSetColorsRequired = [
    "main",
    "light",
    "dark",
    "background",
    "border",
    "placeholder",
    "shadow",
    "text",
    "link",
] as const;
const colorSetColorsOptional = ["accent", "backgroundGradientAlt"] as const;
const colorSetColors = [
    ...colorSetColorsRequired,
    ...colorSetColorsOptional,
] as const;
const colorSetColorsRequiredZodSchema = z.enum(colorSetColorsRequired);
const colorSetColorsOptionalZodSchema = z
    .enum(colorSetColorsOptional)
    .optional();
const colorSetColorsZodSchema = z.enum(colorSetColors);

type ColorSetColorRequired = (typeof colorSetColorsRequired)[number];
type ColorSetColorOptional = (typeof colorSetColorsOptional)[number];
type ColorSetColor = (typeof colorSetColors)[number];

export {
    colorSetColors,
    colorSetColorsOptional,
    colorSetColorsOptionalZodSchema,
    colorSetColorsRequired,
    colorSetColorsRequiredZodSchema,
    colorSetColorsZodSchema,
};
export type { ColorSetColor, ColorSetColorOptional, ColorSetColorRequired };
